module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Italic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Italic.woff2
// module id = 47
// module chunks = 8